import React, { memo } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { Color } from '@atlassian/jira-issue-epic-color/src/common/types.tsx';
import { EpicLozenge } from '@atlassian/jira-issue-field-parent-switcher/src/common/ui/epic-lozenge/index.tsx';
import { EpicTag } from '@atlassian/jira-issue-field-parent-switcher/src/common/ui/epic-tag/index.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch';

export type Props = {
	color: Color | undefined;
	summary: string;
	isCompactView: boolean;
};

export const ParentFieldStatic = ({ color, summary, isCompactView }: Props) => (
	<StaticLozengeWrapper isCompactView={isCompactView}>
		{isVisualRefreshEnabled() ? (
			<EpicTag color={color} summary={summary} isCompactView={isCompactView} />
		) : (
			<EpicLozenge color={color} summary={summary} isCompactView={isCompactView} />
		)}
	</StaticLozengeWrapper>
);

export default memo<Props>(ParentFieldStatic);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StaticLozengeWrapper = styled.div<{ isCompactView: boolean }>(
	{
		display: 'flex',
		alignItems: 'flex-end',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		boxSizing: 'border-box',
		maxWidth: '100%',

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'& div': {
			margin: 0,
		},
	},

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) =>
		!props.isCompactView && {
			paddingLeft: token('space.100', '8px'),
		},
);
